<template>
  <div class="common-uploader">
    <a-upload
      name="file"
      :accept="acceptType"
      :multiple="!isSingle"
      :action="actionUrl"
      :headers="headers"
      ref="upload"
      :fileList="fileList"
      @change="handleUpload"
    >
      <a-button icon="upload">选择文件</a-button>
    </a-upload>
  </div>
</template>

<script>

export default {
  name: 'CommonUploader',
  props: {
    list: Array,
    isSingle: Boolean,
    acceptType: String,
    errorMessage: String
  },
  watch: {
    list: {
      handler (newVal) {
        this.fileList = newVal
      },
      immediate: true
    }
  },
  data () {
    const actionUrl = this.$sysInfo.apiRemote + '/upload/tmp/file'
    return {
      actionUrl: actionUrl,
      headers: {
        Authorization: this.$store.state.user.token
      },
      fileList: []
    }
  },
  computed: {},
  mounted () {},
  methods: {
    listClear () {
      this.fileList = this.list
    },
    handleUpload (info) {
      const fileSize = 5 * 1024 * 1024
      let fileList = info.fileList
      const file = info.file

      if (file.size > fileSize) {
        console.log(file.size)
        this.$message.error(`${file.name} 文件已超出文件上传大小限制，当前限制为5m`)
        const index = fileList.indexOf(file)
        fileList.splice(index)
      }

      if (info.file.status === 'error') {
        this.$message.error('文件上传出错!')
        fileList.map((i, index) => {
          if (i.uid === info.file.uid) {
            fileList.splice(index)
          }
        })
        return
      }
      if (info.file.hasOwnProperty('response') && info.file.response.status !== 0) {
        if (this.errorMessage && info.file.response.status === 1203) {
          this.$message.error(this.errorMessage)
        } else {
          this.$message.error(info.file.response.info.message)
        }
        fileList.map((i, index) => {
          if (i.uid === info.file.uid) {
            fileList.splice(index)
          }
        })
        return
      }
      if (this.isSingle) {
        fileList = fileList.slice(-1)
      }
      // debugger
      fileList = fileList.map(file => {
        if (file.response) {
          file.filePath = file.response.data[0]
          file.fileName = file.name
        }
        return file
      })
      this.fileList = fileList
      this.$emit('handleUpload', this.fileList)
    }
  }
}
</script>
